import styled from 'styled-components';
import { PALETTE_COLORS, SEMANTIC_COLORS } from '@/constant/unit/color';
export const S = {
    FieldBox: styled.div `
    position: relative;

    display: flex;
    flex-wrap: ${(props) => (props.isFull ? 'wrap' : 'no-wrap')};
    align-items: center;

    width: 100%;
    min-height: 53px;
    padding: 7px 14px 7px 16px;
    margin-bottom: 12px;

    background: ${(props) => props.isError
        ? SEMANTIC_COLORS.ERROR_FIELD_BOX_BACKGROUND
        : SEMANTIC_COLORS.DEFAULT_FIELD_BOX_BACKGROUND};
    border-radius: 10px;
  `,
    FieldTitle: styled.label `
    flex-shrink: 0;
    align-self: start;

    padding: 8px 0;

    font-size: 18px;
    font-weight: 500;
    color: ${(props) => props.isError ? SEMANTIC_COLORS.ERROR_TITLE : SEMANTIC_COLORS.DEFAULT_TITLE};
  `,
    InputHidden: styled.input `
    display: none;
  `,
    LayoutRadioButton: styled.div `
    display: flex;
    flex-grow: 1;
    align-self: stretch;
    justify-content: space-between;

    width: ${(props) => (props.isFull ? '100%' : 'auto')};
    height: ${(props) => (props.isFull ? '39px' : 'auto')};
    margin: ${(props) => (props.isFull ? '9px 0 2px' : '0px')};
  `,
    RadioButtonLabel: styled.label `
    display: flex;
    align-items: center;
    justify-content: center;

    width: calc(100% / 3);
    height: 100%;

    cursor: pointer;

    border-right: ${(props) => props.hasBorder ? `1px solid ${PALETTE_COLORS.PRIMARY_600}` : 'none'};
  `,
    RadioButtonTitle: styled.span `
    position: relative;

    font-size: 18px;
    font-weight: ${(props) => (props.isChecked ? 700 : 400)};
    color: ${(props) => props.isChecked ? SEMANTIC_COLORS.PRIMARY_TEXT : SEMANTIC_COLORS.PLACEHOLDER_TEXT};

    &::after {
      position: absolute;
      bottom: -5px;
      left: 50%;

      width: calc(100% + 10px);

      content: '';

      border-bottom: ${(props) => props.isChecked ? `2px solid ${SEMANTIC_COLORS.PRIMARY_BORDER}` : '2px solid transparent'};
      transform: translateX(-50%);
    }
  `,
    FeedbackErrorText: styled.div `
    margin: -12px 0 12px;

    font-size: 16px;
    line-height: 23px;
    color: ${SEMANTIC_COLORS.ERROR_TEXT};
  `,
};
